import { describeArc } from '../utils'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

export const CustomArcLabels: React.FC = (ctx: any) => {
  const arcLabelSkip = 15
  return (
    <g>
      {ctx.nodes.map(
        (node: { data: any; arc: any; path: string[] }, index: number) => {
          const { data, arc, path } = node
          const splitName: string[] = data.name.split('_')

          const startAngle = (arc.startAngle * 180) / Math.PI
          let endAngle = (arc.endAngle * 180) / Math.PI

          if (endAngle - startAngle < arcLabelSkip) return <></>
          if (path?.length !== 2) return <></>
          if (splitName.length === 0) return <></>
          if (startAngle === 0 && endAngle > 359) endAngle = 90

          const radius = (arc.innerRadius + arc.outerRadius) / 2

          const variance = arc.outerRadius - radius - 30 / splitName.length

          return (
            <g pointerEvents={'none'} key={data.name}>
              {splitName.map((sub, index) => {
                const id = uuidv4()
                let dName = describeArc(
                  ctx.centerX,
                  ctx.centerY,
                  arc.outerRadius - 15 - variance * index,
                  startAngle,
                  endAngle
                )

                const avgAngle = (startAngle + endAngle) / 2
                if (avgAngle > 90 && avgAngle < 270) {
                  dName = describeArc(
                    ctx.centerX,
                    ctx.centerY,
                    arc.outerRadius - 5 - variance * index,
                    endAngle,
                    startAngle,
                    true
                  )
                }

                return (
                  <g>
                    <path fill='transparent' id={id} d={dName} />
                    <text textAnchor='middle'>
                      <textPath startOffset={'50%'} href={`#${id}`}>
                        {sub}
                      </textPath>
                    </text>
                  </g>
                )
              })}
            </g>
          )
        }
      )}
    </g>
  )
}
